module.exports = __webpack_public_path__ + "static/img/xinghuajie.4bddd66.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/xinghuajie.png
// module id = grXJ
// module chunks = 52